<template>
  <div>
    <base-header class="pb-6" style="background-color: #248dc1 !important;">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">{{$store.state.user.sponsor_branch}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <!--
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
          -->
        </div>
      </div>
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-6 col-md-6">
          <stats-card :title="'Mis Ventas '+name_current_month"
                      type="gradient-green"
                      :sub-title="ventas_current_month.toString()"
                      icon="ni ni-chart-bar-32">

            <template slot="footer" >
              <div v-html="ventasMesContent">

              </div>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-6 col-md-6">
          <stats-card :title="'Total Ventas '+name_current_month"
                      type="gradient-orange"
                      :sub-title="ventas_current_month_total.toString()"
                      icon="ni ni-chart-pie-35">

            <template slot="footer">
              <div v-html="ventasMesTotalContent">
              </div>
            </template>
          </stats-card>
        </div>
        <!--
        <div class="col-xl-3 col-md-6">
          <stats-card title="Sales"
                      type="gradient-green"
                      sub-title="924"
                      icon="ni ni-money-coins">

            <template slot="footer">
              <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>

        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="Performance"
                      type="gradient-info"
                      sub-title="49,65%"
                      icon="ni ni-chart-bar-32">

            <template slot="footer">
              <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </div>
        -->
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-8">
          <card type="default" header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-light text-uppercase ls-1 mb-1">Revisión individual</h6>
                <h5 class="h3 text-white mb-0">Volumen de ventas</h5>
              </div>
              <!--
              <div class="col">
                <ul class="nav nav-pills justify-content-end">
                  <li class="nav-item mr-2 mr-md-0">
                    <a class="nav-link py-2 px-3"
                       href="#"
                       :class="{active: bigLineChart.activeIndex === 0}"
                       @click.prevent="initBigChart(0)">
                      <span class="d-none d-md-block">Month</span>
                      <span class="d-md-none">M</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link py-2 px-3"
                       href="#"
                       :class="{active: bigLineChart.activeIndex === 1}"
                       @click.prevent="initBigChart(1)">
                      <span class="d-none d-md-block">Week</span>
                      <span class="d-md-none">W</span>
                    </a>
                  </li>
                </ul>
              </div>
              -->
            </div>
            <line-chart
              :height="350"
              ref="bigChart"
              :chart-data="bigLineChart.chartData"
              :extra-options="bigLineChart.extraOptions"
            >
            </line-chart>

          </card>
        </div>

        <div class="col-xl-4">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Revisión General</h6>
                <h5 class="h3 mb-0">Total de ventas</h5>
              </div>
            </div>

            <bar-chart
              :height="350"
              ref="barChart"
              :chart-data="redBarChart.chartData"
            >
            </bar-chart>
          </card>
        </div>
      </div>
      <!-- End charts-->
      <div class="row">
        <div class="col-md-12">
          <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
            <template slot="header">
              <h3 class="mb-0">Sucursal: {{$store.state.user.sponsor_branch}}</h3>
              <p class="text-sm mb-0">
                
              </p>
            </template>
            <div>
              <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>

                <div>
                  <base-input v-model="searchQuery"
                              prepend-icon="fas fa-search"
                              placeholder="Realizar búsqueda...">
                  </base-input>
                </div>
              </div>
              <div class="table-responsive">
                <el-table :data="queriedData"
                          row-key="id"
                          class="table-responsive table"
                          header-row-class-name="thead-light"
                          @sort-change="sortChange"
                          @selection-change="selectionChange">
                  <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    v-bind="column"
                    :width="column.type == 'selection' ? '40px' : (column.label == 'id' ? '90px' : '200px')"
                  >
                  </el-table-column>
                  <el-table-column min-width="200px" align="right" label="fecha_confirmacion">
                    <div slot-scope="{$index, row}" class="d-flex">
                      {{$moment(row['fecha_confirmacion']).format('DD-MM-YYYY HH:mm')}}
                    </div>
                  </el-table-column>
                  <el-table-column min-width="200px" align="right" label="Venta">
                    <div slot-scope="{$index, row}" class="d-flex">
                      <base-button
                        v-if="row.requiere_venta"
                        @click.native="ingresarNroVenta(row.id)" 
                        class="edit"
                        type="success"
                        size="sm"
                        icon
                      >
                        <i class="text-white ni ni-collection"></i> Número de venta
                      </base-button>
                    </div>
                  </el-table-column>
                  <el-table-column min-width="180px" align="right" label="Firma">
                    <div slot-scope="{$index, row}" class="d-flex">
                      <base-button
                        v-if="row.requiere_firma"
                        @click.native="ingresarFirma(row.id)"
                        class="edit"
                        type="primary"
                        size="sm"
                        icon
                      >
                        <i class="text-white ni ni-ruler-pencil"></i> Ingresar firma
                      </base-button>
                    </div>
                  </el-table-column>
                  <el-table-column min-width="180px" align="right" label="Propuesta">
                    <div slot-scope="{$index, row}" class="d-flex">
                      <base-button
                        @click.native="verContrato(row.id)"
                        class="edit"
                        type="default"
                        size="sm"
                        icon
                      >
                        <i class="text-white fa fa-file"></i> Ver propuesta
                      </base-button>
                    </div>
                  </el-table-column>
                  <el-table-column min-width="180px" align="right" label="Acciones">
                    <div slot-scope="{$index, row}" class="list-group list-group-flush w-100 align-items-stretch">
                      
                      <base-button
                        style="margin-right: 0rem;"
                        @click.native="confirmarVenta(row.id)"
                        class="edit"
                        type="info"
                        size="sm"
                        icon
                        :disabled="!row.confirmar"
                      >
                        <i class="text-white fa fa-arrow-right"></i> Confirmar
                      </base-button>
                      &nbsp;
                      <base-button
                        @click.native="$emit('loadModalEditVenta', row.id)"
                        class="edit"
                        type="warning"
                        size="sm"
                        icon
                        :disabled="!$can('update', 'ventas') || row.estado != 'TERMINADO'"
                      >
                        <i class="text-white ni ni-settings"></i> Editar
                      </base-button>
                    </div>
                  </el-table-column>
                  <el-table-column min-width="180px" align="right" label="Eliminar">
                    <div slot-scope="{$index, row}" class="list-group list-group-flush">
                      
                      <base-button
                        style="margin-right: 0rem;"
                        @click.native="eliminarVenta(row)"
                        class="edit"
                        type="danger"
                        size="sm"
                        icon
                      >
                        <i class="text-white fa fa-trash"></i>
                      </base-button>
                    </div>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="">
                <p class="card-category">
                  Mostrando desde {{ from + 1 }} al {{ to }} de un total de {{ total }} registros

                  <span v-if="selectedRows.length">
                    &nbsp; &nbsp; {{selectedRows.length}} registros seleccionados
                  </span>
                </p>

              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </base-pagination>
            </div>
          </card>
        </div>
      </div>
      
      
    </div>
    <modal-pdf ></modal-pdf>
    <modal-firma @firmaSuccess="fetchData"></modal-firma>
    <ingresar-nro-venta></ingresar-nro-venta>
    <modal-edit-venta @successSending="fetchData" ></modal-edit-venta>
  </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // Components
  import BaseProgress from '@/components/BaseProgress';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';

  // Lists
  import ActivityFeed from '@/views/Dashboard/ActivityFeed';
  import TaskList from '@/views/Dashboard/TaskList';
  import UserList from '@/views/Dashboard/UserList';
  import ProgressTrackList from '@/views/Dashboard/ProgressTrackList';

  // Tables
  import LightTable from '@/views/Dashboard/LightTable';
  import SocialTrafficTable from '@/views/Dashboard/SocialTrafficTable';
  import PageVisitsTable from '@/views/Dashboard/PageVisitsTable';

  import { Table, TableColumn, Select, Option } from 'element-ui';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin'
  import { BasePagination } from '@/components';
  import Fuse from 'fuse.js';
  import ModalPdf from '@/views/Cart/ModalPdf.vue';
  import ModalFirma from '@/views/Cart/ModalFirma.vue';

  import IngresarNroVenta from '@/views/VentasPlanes/IngresarNroVenta.vue';

  import swal from 'sweetalert2';

  import ModalEditVenta from '@/views/VentasPlanes/ModalEditVenta.vue';

  export default {
    mixins: [clientPaginationMixin],
    components: {
      ActivityFeed,
      LineChart,
      BarChart,
      BaseProgress,
      RouteBreadCrumb,
      StatsCard,
      TaskList,
      PageVisitsTable,
      SocialTrafficTable,
      LightTable,
      UserList,
      ProgressTrackList,
      BasePagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      ModalPdf,
      ModalFirma,
      IngresarNroVenta,
      ModalEditVenta
    },
    data() {
      return {
        propsToSearch: ['estado', 'plan'],
        tableColumns: [
        ],
        arregloPuedeConfirmar: [],
        arregloRequiereFirma: [],
        arregloRequiereVenta: [],
        tableData: [],
        selectedRows: [],
        bigLineChart: {
          allData: [
            [0, 20, 10, 30, 99, 40, 20, 60, 60],
            [0, 20, 5, 25, 10, 30, 15, 40, 40]
          ],
          activeIndex: 0,
          chartData: {
            datasets: [
              {
                label: 'Performance',
                data: [0, 20, 10, 30, 99, 40, 20, 60, 60],
              }
            ],
            labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },
        redBarChart: {
          chartData: {
            labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
              label: 'Sales',
              data: [25, 20, 30, 22, 17, 29]
            }]
          },
          extraOptions: chartConfigs.blueChartOptions
        },
        ventas_current_month: 0,
        ventas_last_month: 0,
        ventas_current_month_total: 0,
        ventas_last_month_total: 0,
        name_current_month: '',
        name_last_month: ''
      };
    },
    computed: {
      ventasMesContent(){
        if( this.ventas_last_month < 1 ){
          return `<span class="text-success mr-2"><i class="fa fa-arrow-up"></i></span>
              <span class="text-nowrap">0 ventas en ${this.name_last_month}</span>`;
        }else{
          let porcentaje = (this.ventas_current_month-this.ventas_last_month)*100/this.ventas_last_month;
          if( porcentaje >= 100 ){
            return `<span class="text-success mr-2"><i class="fa fa-arrow-up"></i> ${porcentaje}%</span>
              <span class="text-nowrap">respecto a ${this.name_last_month}</span>`;
          }else{
            return `<span class="text-success mr-2"><i class="fa fa-arrow-down"></i> ${porcentaje}%</span>
              <span class="text-nowrap">respecto a ${this.name_last_month}</span>`;
          }
        }
      },
      ventasMesTotalContent(){
        if( this.ventas_last_month_total < 1 ){
          return `<span class="text-success mr-2"><i class="fa fa-arrow-up"></i></span>
              <span class="text-nowrap">0 ventas en ${this.name_last_month}</span>`;
        }else{
          let porcentaje = (this.ventas_current_month_total-this.ventas_last_month_total)*100/this.ventas_last_month;
          if( porcentaje >= 100 ){
            return `<span class="text-success mr-2"><i class="fa fa-arrow-up"></i> ${porcentaje}%</span>
              <span class="text-nowrap">respecto a ${this.name_last_month}</span>`;
          }else{
            return `<span class="text-success mr-2"><i class="fa fa-arrow-down"></i> ${porcentaje}%</span>
              <span class="text-nowrap">respecto a ${this.name_last_month}</span>`;
          }
        }
      }
    },
    methods: {
      eliminarVenta(row){
        swal({
          title: 'Estás seguro?',
          text: `Si la venta tiene siniestros, primero se tienen que eliminar sus siniestros`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Si',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            var vm = this;
            
            console.log(row);
            this.axios({
              url: 'api/ventas/eliminar',
              method: 'POST',
              data: {
                venta_id: row.id
              }
            }).then( response => {
              vm.fetchData();
              swal({
                title: 'Venta Eliminada!',
                text: `Has eliminado la venta ID: ${row.id}`,
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
              });
            }).catch( error => {
              console.log(error);
              vm.$notify({ type: 'danger', message: error.response.data});
            });
            
          }
        });
      },
      initBigChart(index) {
        let chartData = {
          datasets: [
            {
              label: 'Performance',
              data: this.bigLineChart.allData[index]
            }
          ],
          labels: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        };
        this.bigLineChart.chartData = chartData;
        this.bigLineChart.activeIndex = index;
      },
      selectionChange(selectedRows) {
        this.selectedRows = selectedRows
      },
      verContrato(venta)
      {
          this.$emit('loadModalPdf', venta);
      },
      ingresarFirma(venta_id)
      {
          this.$emit('loadModalFirma', venta_id);
      },
      ingresarNroVenta(venta_id)
      {
        this.$emit('loadModalNroVenta', venta_id);
      },

      confirmarVenta(venta_id)
      {

        var vm = this;
        swal({
          title: 'Estás segur@?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Si, vamos!',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.axios({
              method: 'POST',
              url: 'api/ventas/confirm_purchase',
              data: {
                venta: venta_id
              }
            }).then( response => {
              vm.fetchData();
              vm.$notify({
                message: 'Venta confirmada correctamente',
                type: 'success'
              });
            }).catch( error => {
              vm.$notify({
                message: 'Hubo un error, no se pudo confirmar la venta',
                type: 'danger'
              });
              console.log(error);
            });
          }
        });
            
      },
      fetchData()
      {
        var vm = this;
        this.axios({
          url: 'api/ventas/data_management',
          method: 'GET',
        }).then(response => {
          vm.ventas_current_month = response.data.ventas_current_month;
          vm.ventas_last_month = response.data.ventas_last_month;
          vm.ventas_current_month_total = response.data.ventas_current_month_total;
          vm.ventas_last_month_total = response.data.ventas_last_month_total;
          vm.name_current_month = response.data.name_current_month;
          vm.name_last_month = response.data.name_last_month;
          vm.bigLineChart.chartData = {
            datasets: [{ label: 'Ventas', data: response.data.ventas_data_chart }],
            labels: response.data.ventas_meses_labels
          };
          vm.bigLineChart.activeIndex = 0;
          
          vm.redBarChart.chartData = {
            datasets: [
                {
                  label: 'Total ventas',
                  data: response.data.ventas_total_data_chart,
                }
              ],
              labels: response.data.ventas_total_meses_labels,
          };

          let columnas;
          if( response.data.dataTable.data.length > 0 ) columnas = Object.getOwnPropertyNames(response.data.dataTable.data[0]);
          vm.tableData = response.data.dataTable.data.map( (e, iiindice) => ({ ...e, confirmar: response.data.arregloConfirmar[iiindice], requiere_firma: response.data.arregloRequiereFirma[iiindice]  , requiere_venta: response.data.arregloRequiereVenta[iiindice] }) );
          vm.propsToSearch = columnas;
          vm.tableColumns = [];
          vm.tableColumns.push({ type: 'selection' });
          columnas.forEach( item => {
            vm.tableColumns.push({ prop: item, label: item, sortable: true,  });
          } );
          vm.fuseSearch = new Fuse(vm.tableData, {
            keys: vm.propsToSearch,
            threshold: 0.3
          });
          /*
          vm.arregloPuedeConfirmar = response.data.arregloConfirmar;
          vm.arregloRequiereFirma = response.data.arregloRequiereFirma;
          vm.arregloRequiereVenta = response.data.arregloRequiereVenta;
          */
        }).catch( error => {
          console.log(error);
        });
      }
    },
    mounted() {
      this.fetchData();
    }
  };
</script>
<style></style>
